import { useEffect, useState } from 'react';
import { readJson, writeJson } from '../lib/persist';

/**
 * useState that survives refresh via sessionStorage or localStorage.
 * Only for small UI prefs / mock workspace data — not server entities.
 */
export function usePersistedState(key, initialValue, options = {}) {
  const storage = options.storage === 'local' ? localStorage : sessionStorage;
  const [state, setState] = useState(() => {
    const stored = readJson(storage, key, undefined);
    if (stored === undefined) {
      return typeof initialValue === 'function' ? initialValue() : initialValue;
    }
    return stored;
  });

  useEffect(() => {
    writeJson(storage, key, state);
  }, [key, state, storage]);

  return [state, setState];
}
